import Tooltip from "@components/ui/tooltip";
import { cn } from "@lib/cn";
import type { ReactNode } from "react";

interface IProps {
  className?: string;
  onClick: () => void;
  icon: ReactNode;
  label: string;
  tooltip: string;
}

export const CropperDialogActionBtn = ({
  className,
  onClick,
  tooltip,
  label,
  icon,
}: IProps) => {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <button
          type="button"
          className={cn(
            className,
            "tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-1 tw-rounded-lg tw-p-2 tw-outline-none tw-transition-all tw-duration-200 tw-ease-in-out hover:tw-bg-blue-100",
          )}
          onClick={onClick}
        >
          <span className="tw-flex tw-size-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-fill-blue tw-text-blue [&_svg]:tw-size-4">
            {icon}
          </span>
          {/* Labels collapse below sm — toolbar becomes icon-only so it
              fits inside the chrome-extension panel. Tooltip still works
              on hover/long-press, so the icon stays discoverable. */}
          <span className="tw-hidden sm:tw-inline tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-blue-base">
            {label}
          </span>
        </button>
      </Tooltip.Trigger>
      <Tooltip.Content className="tw-z-[10000]">
        <Tooltip.Text>{tooltip}</Tooltip.Text>
      </Tooltip.Content>
    </Tooltip>
  );
};
